export var GroupMark = 'group';
export var RectMark = 'rect';
export var RuleMark = 'rule';
export var SymbolMark = 'symbol';
export var TextMark = 'text';



// WEBPACK FOOTER //
// ./~/vega-parser/src/parsers/marks/marktypes.js